export default __webpack_public_path__ + "static/media/ip_er.e8fbc072.png";